import React from 'react';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import classes from './Card.module.scss';

interface IProps {
  title: string;
  description: string | JSX.Element;
  image: string;
  className?: string;
  onClick?: () => void;
}

const Help: React.FC<IProps> = ({ title, image, description, className, onClick }) => {
  const { t } = useTranslation();

  return (
    <div className={cx(classes.wrapper, classes.wrapperHelp, className)} {...{ onClick }}>
      <div className={classes.image}>
        <img src={image} />
      </div>
      <div className={classes.content}>
        <div className={classes.title}>{title}</div>
        <div className={classes.description}>{description}</div>
        <div className={classes.link}>{t('read_more')}</div>
      </div>
    </div>
  );
};

export default Help;
